import { render, staticRenderFns } from "./HouseType.vue?vue&type=template&id=0e9fb183"
import script from "./HouseType.vue?vue&type=script&lang=js"
export * from "./HouseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports